import { useState } from 'react';
import Button from 'components/common/Button/Button';
import Dialog from 'components/common/Dialog/Dialog';
import PromptDialog from 'components/common/Dialog/PromptDialog';
import ConfirmDialog from 'components/common/Dialog/ConfirmDialog';

/**
 * Examples of Scalyr's dialog component
 */

function DialogExamplePage(): JSX.Element {
  const [showDialogExample, setShowDialogExample] = useState(false);
  const [showPromptDialogExample, setShowPromptDialogExample] = useState(false);
  const [showConfirmDialogExample, setShowConfirmDialogExample] = useState(false);
  const [promptValue, setPromptValue] = useState('floop');

  return (
    <section id="dialog" className="ExamplesPage__Section">
      <h1 className="ExamplesPage__SectionTitle">Dialogs</h1>
      <Button className="mr-2" onClick={(): void => setShowDialogExample(true)}>
        Show Basic Dialog
      </Button>
      <Button className="mr-2" onClick={(): void => setShowPromptDialogExample(true)}>
        Show Prompt Dialog
      </Button>
      <Button onClick={(): void => setShowConfirmDialogExample(true)}>Show Confirm Dialog</Button>
      <Dialog title="Dialog" show={showDialogExample} close={(): void => setShowDialogExample(false)}>
        This is the default dialog style. Note that the header is no longer purple.
      </Dialog>
      <PromptDialog
        title="Rename API Key"
        label="Key Name"
        show={showPromptDialogExample}
        close={(): void => setShowPromptDialogExample(false)}
        value={promptValue}
        onChange={(ev): void => {
          const target = ev.target as HTMLInputElement;
          setPromptValue(target.value);
        }}
        onSubmit={(): void => {}}
      />
      <ConfirmDialog
        title="Delete?"
        text="This action can't be undone"
        show={showConfirmDialogExample}
        close={(): void => setShowConfirmDialogExample(false)}
        onSubmit={(): void => {}}
      />
    </section>
  );
}

export default DialogExamplePage;
